import { Field } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import TextField from '../TextField'
import { PW_MANAGER_OFF } from '../../util/inputAttrs'

const propTypes = {
  /**
   * id of the field. The id passed is also bound to the field's name
   */
  id: PropTypes.string.isRequired,
  /**
   * When false, value is not trimmed on blur (e.g. multiline PEM / XML).
   */
  trimOnBlur: PropTypes.bool,

  disablePasswordManager: PropTypes.bool,
  /**
   * When true, show error state whenever meta.error is set (not only after blur/touched).
   */
  showErrorWhenInvalid: PropTypes.bool,
}

/**
 * Connects the TextField with Formik
 */
function FormikTextField(props) {
  const { id, trimOnBlur = true, disablePasswordManager, showErrorWhenInvalid = false, ...rest } = props ?? {}

  return (
    <Field name={id}>
      {({ field, meta, form }) => {
        const showError = Boolean(meta.error) && (showErrorWhenInvalid || meta.touched)
        return (
          <TextField
            {...rest}
            {...(disablePasswordManager ? PW_MANAGER_OFF : {})}
            id={id}
            name={id}
            onChange={field.onChange}
            onBlur={(event) => {
              let next = field.value
              if (trimOnBlur !== false && typeof field.value === 'string') {
                next = field.value.trim()
              }
              form.setFieldValue(id, next)
              field.onBlur(event)
            }}
            value={field.value ?? ''}
            errors={showError ? [meta.error] : []}
          />
        )
      }}
    </Field>
  )
}

FormikTextField.propTypes = propTypes

export default FormikTextField
